import MessageList from './MessageList';
import ChatInput from './ChatInput';

export default function ChatWindow() {
  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 pb-24">
        <MessageList />
      </div>
      <ChatInput />
    </div>
  );
}
